module.exports = __webpack_public_path__ + "img/produit_11.c0574226.png";